import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { goalService } from '../services';

export function useGoals(params) {
  return useQuery({
    queryKey: ['goals', params],
    queryFn: () => goalService.list(params),
  });
}

export function useGoal(id) {
  return useQuery({
    queryKey: ['goal', id],
    queryFn: () => goalService.get(id),
    enabled: Boolean(id),
  });
}

export function useUpdateGoal() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }) => goalService.update(id, data),
    onSuccess: (_data, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['goals'] });
      queryClient.invalidateQueries({ queryKey: ['goal', id] });
    },
  });
}

export function useCreateGoal() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: goalService.create,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['goals'] }),
  });
}

export function useCompleteGoal() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: goalService.complete,
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: ['goals'] });
      queryClient.invalidateQueries({ queryKey: ['goal', id] });
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}
